const state = {
  messageQueue: [],
};

export const getMessageQueue = () => state.messageQueue;

export const addToMessageQueue = (message) => {
  state.messageQueue.push(message);
};

export const clearMessageQueue = () => {
  state.messageQueue = [];
};
